import React, { useEffect, useState } from "react";
import { Form, Input, Button, Select, Spin, Typography, Row, Col, message } from "antd";
import Password from "antd/lib/input/Password";
import useFetchWithToken from "../../services/api";

const { Option } = Select;
const { Title } = Typography;

const UserForm = ({ formData, setFormData, closeModal, refetchData }) => {
  const [form] = Form.useForm();
  const { data: roles, loading: rolesLoading, error: rolesError } = useFetchWithToken("roles");
  const { postData, putData } = useFetchWithToken("users");

  useEffect(() => {
    if (formData) {
      form.setFieldsValue(formData);
    }
  }, [formData, form]);

  const onFinish = async (values) => {
    try {
      if (formData?.id) {
        await putData(values, formData.id);
        message.success("User updated successfully!");
      } else {
        await postData(values);
        message.success("User created successfully!");
      }
      setFormData({});
      closeModal();
      if (refetchData) refetchData(); // Refetch data after submission
    } catch (error) {
      console.error("Error:", error);
      message.error("Failed to save user.");
    }
  };

  if (rolesError) {
    return <div style={{ textAlign: "center", color: "red" }}>Error: {rolesError}</div>;
  }

  return (
    <Spin spinning={rolesLoading} tip="Loading Roles...">
      <div style={{ padding: "20px" }}>
        <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
          {formData?.id ? "Edit User" : "Add User"}
        </Title>
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="First Name"
                name="firstName"
                rules={[{ required: true, message: "Please enter a First Name" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Last Name"
                name="lastName"
                rules={[{ required: true, message: "Please enter a Last Name" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Email"
                name="email"
                rules={[{ required: true, message: "Please enter an Email" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Phone Number"
                name="phoneNumber"
                rules={[{ required: true, message: "Please enter a Phone Number" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true, message: "Please enter a Password" }]}
              >
                <Password />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Role"
                name="RoleId"
                rules={[{ required: true, message: "Please select a Role" }]}
              >
                <Select>
                  {roles &&
                    roles.map((role) => (
                      <Option key={role.id} value={role.id}>
                        {role.name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Status"
                name="status"
                rules={[{ required: true, message: "Please select a Status" }]}
              >
                <Select>
                  <Option value="Active">Active</Option>
                  <Option value="Inactive">Inactive</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                backgroundColor: "#0c8c49",
                borderColor: "#0c8c49",
              }}
            >
              Save
            </Button>
            <Button
              htmlType="button"
              onClick={() => form.resetFields()}
              style={{
                marginLeft: "10px",
              }}
            >
              Reset
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Spin>
  );
};

export default UserForm;
